import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';
// import '../entrypoints/src/admin/components/bs_collapse';

import { Controller } from "stimulus";
import { isEmpty } from 'lodash-es';
import AppointmentService from "../entrypoints/src/admin/services/appointment-service";
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';

export default class extends Controller {
  static targets = ['modal', 'inputNode', 'trix', 'internal'];

  static values = {
    appointmentUrl: String
  }

  connect() {
    if (this.element.querySelectorAll('.historic-notes li').length == 0)
      return;

    this.element.querySelectorAll('.historic-notes li').forEach(($li) => {
      $li.addEventListener('click', (ev) => {
        // Let links inside a note open normally instead of triggering the editor.
        if (ev.target.closest('a'))
          return;

        ev.preventDefault();
        this.seeNote($li);
      });
    });

    $(this.modalTarget).on('shown.bs.modal', () => this.element.focus());
  }

  seeNote($li) {
    this.selectedNote = $li;
    this.trixTarget.value = this.noteContent($li);
    this.internalTarget.checked = $li.dataset.noteInternal === 'true';
    this.toggleInternalHighlight();
    $(this.modalTarget).modal('show');
  }

  noteContent($li) {
    let template = $li.querySelector('[data-note-content]');
    return template ? template.innerHTML : '';
  }

  // Highlights the editor in yellow while the note is marked as internal,
  // mirroring the shareable note controller's confidential-note styling.
  toggleInternalHighlight() {
    let isInternal = this.internalTarget.checked;
    this.trixTarget.style.backgroundColor = isInternal ? '#fef3c7' : '';
    this.trixTarget.style.border = isInternal ? '1px solid #fde68a' : '';
  }

  async updateCurrentNote() {
    try {
      if (!this.selectedNote || isEmpty(this.inputNodeTarget.value))
        return;

      AjaxLoader.show();
      let $li = this.selectedNote,
        note = this.inputNodeTarget.value,
        isInternal = this.internalTarget.checked,
        locationId = $li.dataset.location,
        enrollemntContract = $li.dataset.enrollmentContractId,
        appointmentData = { 'note': note, 'note_internal': isInternal };

      if (!!locationId)
        appointmentData['location_id'] = locationId;

      if (!!enrollemntContract)
        appointmentData['enrollment_contract_id'] = enrollemntContract;

      await AppointmentService.post(`${this.appointmentUrl($li)}.json`, true, { appointment: appointmentData });
      let template = $li.querySelector('[data-note-content]');
      if (template)
        template.innerHTML = note;
      $li.dataset.noteInternal = isInternal ? 'true' : 'false';
      // Keep links clickable in the preview after an in-place edit (line-clamp trims overflow).
      $li.querySelector('.text-note').innerHTML = note;
      $li.querySelector('.new-message-wrapper').classList.toggle('d-none', true);
      $li.querySelector('.edit-wrapper').classList.toggle('d-none', false);
      this.refreshVisibilityBadge($li, isInternal);
      AjaxLoader.hide();
    } finally {
      $(this.modalTarget).modal('hide');
    }
  }

  refreshVisibilityBadge($li, isInternal) {
    let badge = $li.querySelector('.js-note-visibility');
    if (!badge)
      return;

    let color = isInternal ? 'amber' : 'emerald',
      label = isInternal ? 'Interna' : 'Pública';

    badge.className = `js-note-visibility inline-flex items-center gap-1.5 font-medium text-${color}-700`;
    badge.innerHTML = `<span class="w-2 h-2 rounded-full bg-${color}-500"></span>${label}`;
  }

  appointmentUrl($note) {
    return decodeURIComponent(this.appointmentUrlValue)
      .replace(':batch_schedule_id', $note.dataset.batchScheduleId)
      .replace(':service_id', $note.dataset.serviceId)
      .replace(':date', $note.dataset.date)
      .replace(':start_time', $note.dataset.startTime)
      .replace(':end_time', $note.dataset.endTime)
      .replace(':enrollment_contract_id', $note.dataset.enrollmentContractId)
      .replace(':enrollment_contract_schedule_id', $note.dataset.enrollmentContractScheduleId);
  }
};